export default __webpack_public_path__ + "static/media/branch.e2008545.svg";